import { Link } from "react-router-dom";

const friendLinks = [
  { label: "香港电影资料馆", href: "https://911chigua1.asia/" },
  { label: "电影分级制度说明", href: "https://www.ofnaa.gov.hk/" },
  { label: "光影档案 · 影评专栏", href: "#" },
  { label: "经典港片修复计划", href: "#" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 w-full bg-primary-900 text-background-50">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide">香港三级片</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">
              一个专注于香港三级片（Category III）电影的资料档案站，提供电影介绍、剧情解析与多维度分类导航，
              帮助观众与研究者系统了解该类型电影的历史脉络与代表作品。本站仅作资料展示，不提供任何影片播放或下载。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wide text-background-50">
              <a href="/about" className="cursor-pointer">快速导航</a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-100/80">
              <li><Link to="/" className="cursor-pointer transition-colors hover:text-background-50">首页</Link></li>
              <li><Link to="/category/1990s" className="cursor-pointer transition-colors hover:text-background-50">分类浏览</Link></li>
              <li><Link to="/search" className="cursor-pointer transition-colors hover:text-background-50">搜索检索</Link></li>
              <li><Link to="/about" className="cursor-pointer transition-colors hover:text-background-50">关于本站</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wide text-background-50">
              <a href="/about" className="cursor-pointer">友情链接</a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-100/80">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href.startsWith("http") ? "_blank" : undefined}
                    rel={link.href.startsWith("http") ? "noreferrer" : undefined}
                    className="cursor-pointer transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700/60 pt-6 text-xs text-primary-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 香港三级片 · 影视资料站　保留所有权利</p>
          <p>本站内容仅用于电影资料研究与学习交流，禁止用于任何商业用途</p>
        </div>
      </div>
    </footer>
  );
}